import { useLocation } from "react-router-dom";
import { useWatch } from "react-hook-form";

export const useWeekContext = mode => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const curriculumIdForm = useWatch({ name: "curriculumId" });
  const academicYearSessionIdForm = useWatch({ name: "academicYearSessionId" });
  const schedulesForm = useWatch({ name: "disciplineSchedules" });

  const schedulesUrl = useWatch({ name: "schedules" });

  return mode === "edit"
    ? {
        curriculumId: params.get("curriculumId"),
        academicYearSessionId: params.get("academicYearSessionId"),
        schedules: schedulesUrl,
      }
    : {
        curriculumId: curriculumIdForm,
        academicYearSessionId: academicYearSessionIdForm,
        schedules: schedulesForm,
      };
};
